export const hex2rgba = (hex?: string, opacity: number = 1) => {
    if (!hex) return undefined;
    const [r, g, b] = (hex.match(/\w\w/g) || []).map(x => parseInt(x, 16));
    return `rgba(${r},${g},${b},${opacity})`;
};